import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? "text-purple-800 font-semibold border-b-2 border-purple-800" : "text-gray-600 hover:text-purple-700";

  return (
    <div className="flex flex-col min-h-screen">
      <header className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-serif text-2xl text-purple-900 tracking-wide font-semibold">Can Do</span>
            </Link>
            
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className={isActive('/')}>Home</Link>
              <Link to="/about" className={isActive('/about')}>The Method</Link>
              <Link to="/services" className={isActive('/services')}>Services</Link>
              <Link to="/contact" className={isActive('/contact')}>Contact</Link>
            </nav>

            <button 
              className="md:hidden p-2 text-gray-600"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <SafeIcon icon={isMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4 shadow-lg text-center">
            <div className="flex flex-col space-y-4 px-6">
              <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-gray-800 py-2">Home</Link>
              <Link to="/about" onClick={() => setIsMenuOpen(false)} className="text-gray-800 py-2">The Method</Link>
              <Link to="/services" onClick={() => setIsMenuOpen(false)} className="text-gray-800 py-2">Services</Link>
              <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="text-gray-800 py-2">Contact</Link>
            </div>
          </div>
        )}
      </header>

      <main className="flex-grow">
        {children}
      </main>

      <footer className="bg-slate-50 border-t border-slate-200 mt-auto">
        <div className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-serif text-lg font-semibold text-purple-900 mb-4">Can Do | Development</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Strengths-based baby and early years development monitoring. Based in Saddleworth, supporting families across Greater Manchester and Lancashire.
              </p>
            </div>
            <div>
              <h3 className="font-serif text-lg font-semibold text-purple-900 mb-4">Service Areas</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-purple-700" />
                  <span>Saddleworth & Greater Manchester</span>
                </li>
                <li className="flex items-center gap-2">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-purple-700" />
                  <span>Lancashire, Yorkshire & Derbyshire</span>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-serif text-lg font-semibold text-purple-900 mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><Link to="/about" className="hover:text-purple-800">The Can Do Method</Link></li>
                <li><Link to="/services" className="hover:text-purple-800">Monitoring Packages</Link></li>
                <li><Link to="/contact" className="hover:text-purple-800">Book an Observation</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-200 mt-12 pt-8 text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Can Do Early Years Development. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;